
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"62","height":"65","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"filter":"url(#filter0_d_1742_19013)"}},[_c('rect',{attrs:{"x":"10","y":"23.5","width":"41.333","height":"31","rx":"10.333","stroke":"#fff","stroke-width":"3.875"}}),_c('path',{attrs:{"d":"M41 23.5v-5.167C41 12.626 36.373 8 30.666 8v0c-5.707 0-10.333 4.626-10.333 10.333V23.5","stroke":"#fff","stroke-width":"3.875"}}),_c('circle',{attrs:{"cx":"31","cy":"39","r":"3","fill":"#fff"}})]),_c('defs',[_c('filter',{attrs:{"id":"filter0_d_1742_19013","x":"-4","y":"0","width":"70","height":"70","filterUnits":"userSpaceOnUse","color-interpolation-filters":"sRGB"}},[_c('feFlood',{attrs:{"flood-opacity":"0","result":"BackgroundImageFix"}}),_c('feColorMatrix',{attrs:{"in":"SourceAlpha","values":"0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0","result":"hardAlpha"}}),_c('feOffset',{attrs:{"dy":"4"}}),_c('feGaussianBlur',{attrs:{"stdDeviation":"2"}}),_c('feComposite',{attrs:{"in2":"hardAlpha","operator":"out"}}),_c('feColorMatrix',{attrs:{"values":"0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"}}),_c('feBlend',{attrs:{"in2":"BackgroundImageFix","result":"effect1_dropShadow_1742_19013"}}),_c('feBlend',{attrs:{"in":"SourceGraphic","in2":"effect1_dropShadow_1742_19013","result":"shape"}})])])])
          )
        }
      }
    